<div class="review-header-container">
    <mat-card appearance="raised">
        <mat-card-content>
            <div class="row col-sm-12">
                <div class="col-sm review-header-content">
                    <div class="row">
                        <div class="col-sm-3">
                            <label>{{ 'REVIEW_HEADER_SELECTION' | translate }}:</label>
                        </div>
                        <div class="col-sm-9">{{ selectionName | translate }}</div>
                    </div>
                    <div class="row flex-align-center desc-container">
                        <div class="col-sm-3">
                            <label>{{ 'REVIEW_HEADER_DESCRIPTION' | translate }}:</label>
                        </div>
                        <div class="col-sm-9">
                            <mat-form-field appearance="outline">
                                <input matInput placeholder="{{ 'REVIEW_HEADER_DESCRIPTION' | translate }}"
                                    [formControl]="descriptionControl" trackChanges (change)="onDescriptionChange()">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm review-header-content">
                    <div class="row">
                        <div class="col-sm-3">
                            <label>{{ 'REVIEW_HEADER_SALES_PERSON' | translate }}:</label>
                        </div>
                        <div class="col-sm-9">{{ salesPersonName }}</div>
                    </div>
                    <div class="row flex-align-center">
                        <div class="col-sm-3">
                            <label>{{ 'REVIEW_HEADER_REVIEWER' | translate }}:</label>
                        </div>
                        <div class="col-sm-9">{{ reviewerName }}</div>
                    </div>
                </div>
                @if (costReviewStatus === 'COST_REVIEW_STATUS_IN_PROGRESS') {
                <mat-icon class="refresh-icon" [class.disabled-action]="isReadOnly"
                    [attr.aria-disabled]="isReadOnly" (click)="clickRefresh()">refresh</mat-icon>
                }
                <div class="col-sm review-header-content">
                    <div class="row flex-align-center">
                        <div class="col-sm-2">
                            <label>{{ 'REVIEW_HEADER_STATUS' | translate }}:</label>
                        </div>
                        <div class="col-sm-2 d-flex justify-content-end pe-0 align-items-center">
                            @if (costReviewStatus != 'COST_REVIEW_STATUS_NOT_STARTED') {
                                <mat-icon [matMenuTriggerFor]="reviewerInfoMenu" #menuTrigger="matMenuTrigger"
                                    (mouseenter)="menuTrigger.openMenu()" class="info-icon">info</mat-icon>
                                <mat-menu #reviewerInfoMenu="matMenu" class="reviewer-info-menu">
                                    <div class="reviewer-info-table" (click)="$event.stopPropagation()" (mouseleave)="menuTrigger.closeMenu()">
                                        <table mat-table [dataSource]="reviewerInfoList">
                                            <ng-container matColumnDef="role">
                                                <th mat-header-cell *matHeaderCellDef>{{ 'ROLE' | translate }}</th>
                                                <td mat-cell *matCellDef="let element">{{ element.role }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="reviewer">
                                                <th mat-header-cell *matHeaderCellDef>{{ 'REVIEWER' | translate }}</th>
                                                <td mat-cell *matCellDef="let element">{{ element.reviewer }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef>{{ 'REVIEW_HEADER_STATUS' | translate }}</th>
                                                <td mat-cell *matCellDef="let element">
                                                    <span>{{ element.status | translate }}</span>
                                                    @if (element.date) {
                                                        &nbsp;<span>{{ 'ON' | translate | lowercase }}</span>
                                                        &nbsp;<span>{{ element.date }}</span>
                                                    }
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="reviewerInfoColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: reviewerInfoColumns;"></tr>
                                        </table>
                                    </div>
                                </mat-menu>
                            }
                        </div>
                        <div class="col-sm-8 item-align">
                            <span>{{ costReviewStatus | translate }}</span>
                            @if (autoUnlockMessage) {
                                <span class="auto-unlock-message"> {{ autoUnlockMessage | translate}}</span>
                            }
                            @if (costReviewStatus === 'COST_REVIEW_STATUS_DENIED') {
                                <mat-icon class="notes" (click)="openDeniedNotes()">notes</mat-icon>
                            }
                        </div>
                    </div>
                    <div class="row flex-align-center">
                        <div class="col-sm-4">
                            <label>{{ 'REVIEW_HEADER_DATE_APPROVED' | translate }}:</label>
                        </div>
                        <div class="col-sm-8">{{ dateApproved }}</div>
                    </div>
                </div>
                <div class="col-sm review-header-content">
                    <div class="row gap-between align-items-center">
                        @if (actionNeededVisible) {
                        <mat-icon class="warning-icon">warning</mat-icon>
                        }
                        @if (crButtonMode === 'cancel') {
                        <button mat-raised-button color="warn" class="col-sm-auto"
                            [disabled]="actionNeededVisible || isReadOnly"
                            (click)="clickCancel()">{{ 'CANCEL_BTN_LABEL' | translate }}</button>
                        }
                        @if (crButtonMode === 'request') {
                        <button mat-raised-button color="primary" class="col-sm-auto"
                            [disabled]="actionNeededVisible || isReadOnly"
                            (click)="clickRequest()">{{ 'REQUEST_BTN_LABEL' | translate }}</button>
                        }
                        @if (crButtonMode === 'unlock') {
                        <button mat-raised-button color="primary" class="col-sm-auto"
                            [disabled]="actionNeededVisible || isReadOnly"
                            (click)="clickUnlock()">{{ 'COST_REVIEW_UNLOCK_BTN' | translate }}</button>
                        }
                        @if (actionNeededVisible) {
                        <button mat-raised-button color="warn" class="col-sm-auto"
                            [disabled]="isReadOnly"
                            (click)="clickActionNeeded()">{{ 'ACTION_NEEDED_BTN_LABEL' | translate }}</button>
                        }
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>